module.exports = "/packs/images/facilities~694bd22c5f0dec9041904a7d779c12e9.svg";